var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "article-chapter" },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm._l(_vm.chapter.content, function (section, index) {
        return _c(
          "div",
          {
            key: index,
            ref: `section-${index}`,
            refInFor: true,
            staticClass: "article-section",
            class: [`layout-${section.layout}`, _vm.animationClass(section)],
            style: _vm.sectionStyle(section),
          },
          [
            section.layout === "text_image_left"
              ? [
                  _c("div", { staticClass: "two-col" }, [
                    _c("div", {
                      staticClass: "col-text",
                      domProps: { innerHTML: _vm._s(section.text) },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-image" }, [
                      _c("img", {
                        staticClass: "section-image",
                        attrs: { src: section.image, alt: "" },
                      }),
                    ]),
                  ]),
                ]
              : section.layout === "text_image_right"
              ? [
                  _c("div", { staticClass: "two-col" }, [
                    _c("div", { staticClass: "col-image" }, [
                      _c("img", {
                        staticClass: "section-image",
                        attrs: { src: section.image, alt: "" },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-text",
                      domProps: { innerHTML: _vm._s(section.text) },
                    }),
                  ]),
                ]
              : section.layout === "image"
              ? [
                  _c("div", { staticClass: "article-section-inner" }, [
                    _c("img", {
                      staticClass: "section-image",
                      attrs: { src: section.image, alt: "" },
                    }),
                  ]),
                ]
              : section.layout === "two_columns"
              ? [
                  _c("div", { staticClass: "two-col" }, [
                    _c("div", {
                      staticClass: "col-text",
                      domProps: { innerHTML: _vm._s(section.text) },
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-text",
                      domProps: { innerHTML: _vm._s(section.text_secondary) },
                    }),
                  ]),
                ]
              : [
                  _c("div", { staticClass: "article-section-inner" }, [
                    section.text
                      ? _c("div", {
                          domProps: { innerHTML: _vm._s(section.text) },
                        })
                      : _vm._e(),
                  ]),
                ],
          ],
          2
        )
      }),
      _vm._v(" "),
      _c("div", { staticClass: "article-complete-card" }, [
        _c(
          "a",
          {
            staticClass: "btn primary-btn",
            on: {
              click: function ($event) {
                return _vm.$router.push({
                  name: "categoryDashboard",
                  params: { category: _vm.$route.params.category },
                })
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("ARTICLE_COMPLETE_BACK_BUTTON")))]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }